// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__27Zdj","ranges":"BmiRanges_ranges__1iCdr"};